<template>
  <div class="secondpage">
    <div class="title_top">
      <el-row :gutter="20">
        <el-col :span="16" :offset="4">
          <div class="secondpage_con" v-for="navlistlist in navlist" v-if="workTask == navlistlist.id"
               ::key="navlistlist.id">
            <h2>
              {{ navlistlist.title }}
            </h2>
            <p>
              {{ navlistlist.content }}
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      workTask: [],
      navlist: [{
          title: '企业应用集成',
          id: 32,
          content: '根据项目需求，提供业务系统接口对接及权限配置相关的开发支持，具体服务范围以双方约定为准。'
        },
        {
          title: '数据存储与备份',
          id: 33,
          content: '根据具体项目约定，提供数据存储、备份配置及相关技术支持。'
        },
        {
          title: '网站建设解决方案',
          id: 38,
          content: '根据项目需求，提供网站及业务系统的设计、开发与部署支持，具体服务内容以双方约定为准。'
        }
      ]
    };
  },
  created() {
    this.workTask = this.$route.query.id
  },
  watch: {
    $route() {
      this.workTask = this.$route.query.id
    }
  },
  mounted() {

  }

}
</script>

<style scoped>
.title_top {
  width: 100%;
  overflow: hidden;
  margin: 0;
  color: #FFFFFF;
  background: url(../assets/download.png) no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.secondpage_con {
  text-align: left;
  margin: 150px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/three.vue